<div class="shipment-received-wrapper">
  <h2 mat-dialog-title class="mat-h2">
    Receive Shipment
    <button mat-icon-button class="close-button" (click)="closeDialog('close')">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div class="shipment-received">
      <div class="received-header-title">
        <div class="received-header-left">
          <mat-label class="mat-h2 bold-title">
            {{ config.projectName }}
          </mat-label>
        </div>

        <div class="received-header-right">
          <mat-form-field appearance="outline" class="row-select">
            <mat-select placeholder="Row" [(value)]="selectedRow" (selectionChange)="updateStorageCompartment()">
              <mat-option value="S">Soil(S)</mat-option>
              <mat-option value="P">Precast(P)</mat-option>
              <mat-option value="O">Over Stock(O)</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="section-select">
            <mat-select placeholder="Section" [(value)]="selectedSection" (selectionChange)="updateStorageCompartment()">
              <mat-option value="1">1</mat-option>
              <mat-option value="2">2</mat-option>
              <mat-option value="3">3</mat-option>
              <mat-option value="4">4</mat-option>
              <mat-option value="5">5</mat-option>
              <mat-option value="6">6</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="shelf-select">
            <mat-select placeholder="Shelf" [(value)]="selectedShelf" (selectionChange)="updateStorageCompartment()">
              <mat-option value="A">A</mat-option>
              <mat-option value="B">B</mat-option>
              <mat-option value="C">C</mat-option>
            </mat-select>
          </mat-form-field>

          @if (this.config.projectType !== 'Pre Cast' && ShowPrintBtn()) {
            <button
              mat-raised-button
              class="received-print-button"
              (click)="openInNewTab()">
              <img src="/assets/icons/Print-red.svg" class="export-print-btn" alt="print" />
              PRINT
            </button>
          }
        </div>
      </div>
      <div class="table-container">
        @if (this.config.projectType === 'Pre Cast') {
          <table
            mat-table
            [dataSource]="dataSource"
            class="mat-elevation-z8"
            >
            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef style="width: 15%">Status</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <mat-form-field appearance="outline">
                  <mat-select
                    placeholder="Please Select"
                    [(value)]="element.sampleStatusTypeId"
                    [disabled]="isDisabled[i].isSampleReceived"
                    (selectionChange)="validateForAll()">
                    @for (sampleStatus of sampleStatuses; track sampleStatus) {
                      <mat-option [value]="sampleStatus.id">
                        {{ sampleStatus.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>
            <!-- Sample ID Column -->
            <ng-container matColumnDef="sampleId">
              <th mat-header-cell *matHeaderCellDef style="width: 25%">Sample ID</th>
              <td mat-cell *matCellDef="let element">{{ element.sampleId }}</td>
            </ng-container>
            <!-- Collection Date Column -->
            <ng-container matColumnDef="sampleCollectionDate">
              <th mat-header-cell *matHeaderCellDef style="width: 20%">Collection Date</th>
              <td mat-cell *matCellDef="let element">{{ element.sampleCollectionDate | date:'MM/dd/yyyy' }}</td>
            </ng-container>
            <!-- Material Type Column -->
            <ng-container matColumnDef="materialType">
              <th mat-header-cell *matHeaderCellDef style="width: 15%">Material Type</th>
              <td mat-cell *matCellDef="let element">{{ getPrecastSampleTypeName(element.sampleTypeMasterId) }}</td>
            </ng-container>
            <!-- Mix Design Column -->
            <ng-container matColumnDef="mixDesign">
              <th mat-header-cell *matHeaderCellDef style="width: 15%">Mix Design</th>
              <td mat-cell *matCellDef="let element">{{ element.mixDesignCode }}</td>
            </ng-container>
            <!-- Capture Image Column -->
            <ng-container matColumnDef="capture">
              <th mat-header-cell *matHeaderCellDef style="width: 5%">Capture</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="openCamera(element)" matTooltip="Capture Image">
                  <mat-icon>photo_camera</mat-icon>
                </button>
              </td>
            </ng-container>
            <!-- Header and Row Declarations -->
            <tr mat-header-row *matHeaderRowDef="displayPrecastColumns; sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayPrecastColumns"
              [class.received-row]="row.sampleStatusTypeId === 'd471cab0-df24-4a80-a670-9994fbdf5f6f'"
              [class.missing-row]="row.sampleStatusTypeId === '2320323b-65e5-4270-95ce-6fa221d3c0b5'"
              [class.damaged-row]="row.sampleStatusTypeId === '33de1f0d-8209-4d52-a4c7-18e4918d9932'">
            </tr>
          </table>
        }
        @if (this.config.projectType !== 'Pre Cast') {
          <table
            mat-table
            id="exportTable"
            [dataSource]="dataSource"
            class="mat-elevation-z8"
            >
            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef style="width: 15%">Status</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <mat-form-field appearance="outline" class="status-column">
                  <mat-select
                    placeholder="Please Select"
                    [formControl]="getFormControl(i, 'sampleStatusTypeId')"
                    [(value)]="element.sampleStatusTypeId"
                    (selectionChange)="onStatusChange($event, i)">
                    @for (sampleStatus of sampleStatuses; track sampleStatus) {
                      <mat-option [value]="sampleStatus.id">
                        {{ sampleStatus.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>
            <!-- SampleId Column -->
            <ng-container matColumnDef="sampleId">
              <th mat-header-cell *matHeaderCellDef style="width: 20%">Sample ID</th>
              <td
                mat-cell
                *matCellDef="let element"
                [matTooltip]="element.sampleId"
                matTooltipClass="custom-tooltip"
              [innerHTML]="element.sampleId | format : 'truncate'"></td>
            </ng-container>
            <!-- SampleType Column -->
            <ng-container matColumnDef="sampleType">
              <th mat-header-cell *matHeaderCellDef style="width: 10%">Sample Type</th>
              <td mat-cell *matCellDef="let element">
                {{ element.sampleTypeMasterId === '6f32ebfe-767a-4f27-a295-9dad300d9ba9' ? 'Tube' : 'Bulk' }}
              </td>
            </ng-container>
            <!-- Depth Column -->
            <ng-container matColumnDef="depth">
              <th mat-header-cell *matHeaderCellDef style="width: 10%">Depth</th>
              <td mat-cell *matCellDef="let element">
                @if (!element.stockPile) {
                  <span>
                    {{ displayDepth(element.sampleDepth, element.sampleEndDepth)}}
                  </span>
                }
                @if (element.stockPile) {
                  <span> Stockpile </span>
                }
              </td>
            </ng-container>
            <!-- WeightReceived Column -->
            <ng-container matColumnDef="weightReceived">
              <th mat-header-cell *matHeaderCellDef style="width: 10%" class="text-align">
                <div class="header-weight-received">
                  Weight Received<br />
                  <span>(gm)</span>
                </div>
              </th>
              <td mat-cell *matCellDef="let element; let i = index" class="text-align">
                <form [formGroup]="getFormGroup(i)">
                  <mat-form-field appearance="outline" class="input-form-field">
                    <input
                      matInput
                      [formControl]="getFormControl(i, 'weightReceived')"
                      type="number"
                      maxlength="5"
                      (keypress)="maxlengthCheck($event)"
                      (change)="validateForAll()"
                      [disabled]="element.sampleStatusTypeId === '2320323b-65e5-4270-95ce-6fa221d3c0b5'" />
                    </mat-form-field>
                  </form>
                </td>
              </ng-container>
              <!-- WeightUsed Column -->
              <ng-container matColumnDef="weightUsed">
                <th mat-header-cell *matHeaderCellDef style="width: 10%" class="text-align">
                  <div class="header-weight-received">
                    Weight Used<br />
                    <span>(gm)</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-align">{{ element.weightUsed }}</td>
              </ng-container>
              <!-- WeightRemaining Column -->
              <ng-container matColumnDef="weightRemaining">
                <th mat-header-cell *matHeaderCellDef style="width: 10%" class="text-align">
                  <div class="header-weight-received">
                    Weight Remaining<br />
                    <span>(gm)</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="text-align">{{ element.weightRemaining }}</td>
              </ng-container>
              <!-- Capture Image Column -->
              <ng-container matColumnDef="capture">
                <th mat-header-cell *matHeaderCellDef style="width: 5%">Capture</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button (click)="openCamera(element)" matTooltip="Capture Image">
                    <mat-icon>photo_camera</mat-icon>
                  </button>
                </td>
              </ng-container>
              <!-- Header and Row -->
              <tr mat-header-row *matHeaderRowDef="displayNativeColumns; sticky: true"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayNativeColumns"
                [class.received-row]="row.sampleStatusTypeId === 'd471cab0-df24-4a80-a670-9994fbdf5f6f'"
                [class.missing-row]="row.sampleStatusTypeId === '2320323b-65e5-4270-95ce-6fa221d3c0b5'"
              [class.damaged-row]="row.sampleStatusTypeId === '33de1f0d-8209-4d52-a4c7-18e4918d9932'"></tr>
            </table>
          }
        </div>
        <div class="col-12 mt-16">
          <mat-label class="mat-subtitle-2">Additional Notes</mat-label>
          <mat-form-field appearance="outline" class="text-area">
            <textarea
              class="textarea-popup"
              matInput
              rows="3"
              [(ngModel)]="additionalNotes"
              [ngModelOptions]="{ standalone: true }"
              maxlength="500"
              placeholder="Max 500 characters"
            (input)="onInputChange($event)"></textarea>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <div>
      <mat-divider></mat-divider>
      <mat-dialog-actions align="end">
        <button mat-raised-button (click)="closeDialog('close')">CANCEL</button>
        <button mat-raised-button color="primary" [disabled]="!saveEnabled" (click)="updateStatus()">SAVE</button>
      </mat-dialog-actions>
    </div>
  </div>
